import { render } from "./Separator.vue?vue&type=template&id=328d79d6&ts=true"
import script from "./Separator.vue?vue&type=script&setup=true&lang=ts"
export * from "./Separator.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/separator/Separator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "328d79d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('328d79d6', __exports__)) {
    api.reload('328d79d6', __exports__)
  }
  
  module.hot.accept("./Separator.vue?vue&type=template&id=328d79d6&ts=true", () => {
    api.rerender('328d79d6', render)
  })

}


export default __exports__